import React, { useMemo } from "react";
import classes from "./thumbnail.module.css";
import { useThumbnail } from "../../Pregrine/ProductImageCarousel/useThumbnail";
import placeholder from "../../assets/images/placeholder.webp";
import { IoIosPlayCircle } from "react-icons/io";
const DEFAULT_THUMBNAIL_HEIGHT = 170;
const DEFAULT_THUMBNAIL_WIDTH = 135;

const Thumbnail = (props) => {
  const { isActive, onClickHandler, itemIndex, item } = props;

  const talonProps = useThumbnail({
    onClickHandler,
    itemIndex,
  });

  const { handleClick } = talonProps;

  const thumbnailImage = useMemo(() => {
    return item.__typename === "ProductImage" ? (
      item.url ? (
        <img
          alt={item.label}
          className={classes.image}
          height={DEFAULT_THUMBNAIL_HEIGHT}
          src={item.url}
          width={DEFAULT_THUMBNAIL_WIDTH}
        />
      ) : (
        <img alt={item.label} className={classes.image} src={placeholder} />
      )
    ) : item.url ? (
      <div style={{ position: "relative" }}>
        <video
          src={item.url}
          alt={item.label}
          className={classes.image}
          width={DEFAULT_THUMBNAIL_WIDTH}
          height={DEFAULT_THUMBNAIL_HEIGHT}
        ></video>
        <IoIosPlayCircle
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: `translate(-50%,-50%)`,
          }}
          fontSize={24}
        />
      </div>
    ) : (
      <img alt={item.label} className={classes.image} src={placeholder} />
    );
  }, [item.file, item.label, item.__typename, item.url, classes.image]);

  return (
    <span
      className={isActive ? classes.rootSelected : classes.root}
      onClick={handleClick}
      role="button"
      aria-hidden="true"
    >
      {thumbnailImage}
    </span>
  );
};

export default Thumbnail;
